import { render } from "./UserListItem.vue?vue&type=template&id=198cf46c&scoped=true"
import script from "./UserListItem.vue?vue&type=script&lang=js"
export * from "./UserListItem.vue?vue&type=script&lang=js"

import "./UserListItem.vue?vue&type=style&index=0&id=198cf46c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198cf46c"]])

export default __exports__